export default __webpack_public_path__ + "static/media/waiting.b7e4721e.png";